module.exports = __webpack_public_path__ + "static/media/03B.69d35e80.png";